import EnterVirtualDataForm from './enter-virtual-data-form/enter-virtual-data-form';
import EnterVirtualDataComponent from './enter-virtual-data-component'
import EnterVirtualDataService from './enter-virtual-data-service';
import FilterBar from './filter-bar/filter-bar';

/***
 * The Enter Data page, containing both the filter-bar and the enter-data-form.
 */
const enterVirtualData = angular
    .module('FacilityData.EnterVirtualData', [
        EnterVirtualDataForm,
        FilterBar
    ])
    .component('enterVirtualData', EnterVirtualDataComponent)
    .service('EnterVirtualDataService', EnterVirtualDataService)
    .config(($stateProvider) => {
        'ngInject';
        $stateProvider
            .state('app.enter-virtual-data', {
                url: '/enter-virtual-data/',
                component: 'enterVirtualData',
                resolve: {
                    updateUser: (
                        $state,
                        CurrentUser,
                        EnterVirtualDataFormService
                    ) =>  CurrentUser.updateCurrentUser({}, EnterVirtualDataFormService.autoSaveStats, EnterVirtualDataFormService),
                    userAuth: (
                        $state,
                        updateUser,
                        CurrentUser
                    ) => {
                        if (!CurrentUser.isFacilityAdmin()) {
                            $state.go('app.home', {}, {reload: true});
                        }
                    },
                    clientList: (CommonRequest) => CommonRequest.getClients({has_user_permissions: 1}),
                    changeReasonList: (EnterVirtualDataService) => EnterVirtualDataService.getChangeReasons(),
                    relatedModels: (FacilitySettings) => FacilitySettings.getRelatedModels(),
                    facilityFields: (FacilitySettings) => FacilitySettings.getFacilityFields(),
                }
            });
    })
    .name;

export default enterVirtualData


// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/enter-virtual-data.js